// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"_3hlXs","openButton":"_3Crrb","arrow":"_2kjKX","arrowUp":"_22Q9q","actionText":"_2aTVd","preLabel":"Zk9ac"};